import { __assign, __makeTemplateObject, __rest } from "tslib";
import { css, cx } from 'emotion';
import React from 'react';
import AceEditor from 'react-ace';
//import 'ace-builds/src-min-noconflict/ext-language_tools';
//import 'ace-builds/src-min-noconflict/ext-searchbox';
//import 'ace-builds/src-min-noconflict/ext-spellcheck';
import 'ace-builds/src-min-noconflict/mode-handlebars';
import 'ace-builds/src-min-noconflict/mode-javascript';
import 'ace-builds/src-noconflict/mode-html';
import 'ace-builds/src-noconflict/mode-json';
import 'ace-builds/src-noconflict/theme-github';
import 'ace-builds/src-noconflict/theme-monokai';
import 'bootstrap/dist/css/bootstrap.css';
import 'react-datetime/css/react-datetime.css';
import 'react-mde/lib/styles/css/react-mde-all.css';
//import 'ace-builds/src-min-noconflict/snippets/javascript';
//import 'ace-builds/src-min-noconflict/theme-tomorrow_night_eighties';
//import 'ace-builds/src-noconflict/snippets/html';
var ace = require('ace-builds/src-noconflict/ace');
ace.config.set('basePath', 'https://cdn.jsdelivr.net/npm/ace-builds@1.4.3/src-noconflict/');
ace.config.setModuleUrl('ace/mode/javascript_worker', 'https://cdn.jsdelivr.net/npm/ace-builds@1.4.3/src-noconflict/worker-javascript.js');
export var CodeEditor = function (_a) {
    var mode = _a.mode, theme = _a.theme, name = _a.name, width = _a.width, height = _a.height, value = _a.value, rest = __rest(_a, ["mode", "theme", "name", "width", "height", "value"]);
    var _name = name || Math.random().toString(36).substring(7);
    var _theme = theme === 'light' ? 'github' : 'monokai';
    var _mode = mode || 'handlebars';
    var _height = height || '300px';
    var _width = width || '100%';
    return (React.createElement("div", { className: cx('code-editor', css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n          min-height: ", ";\n        "], ["\n          min-height: ", ";\n        "])), height)) },
        React.createElement(AceEditor, __assign({ mode: _mode, theme: _theme, name: _name, height: _height, width: _width, fontSize: 14, showPrintMargin: true, focus: true, editorProps: { $blockScrolling: true }, wrapEnabled: true, highlightActiveLine: true, autoScrollEditorIntoView: true, value: value, setOptions: {
                enableBasicAutocompletion: true,
                enableLiveAutocompletion: true,
                enableSnippets: true,
                showLineNumbers: true,
                tabSize: 2,
                showGutter: true
            } }, rest))));
};
var templateObject_1;
//# sourceMappingURL=CodeEditor.js.map